import React from 'react';
import { useUser } from '@clerk/clerk-react';
import SystemResourcesOverview from '../components/SystemResourcesOverview';

const SystemResources = () => {
  const { user, isLoaded } = useUser();

  // If user is not authenticated, show empty state
  if (!user) {
    return (
      <div className="space-y-6">
        <div className="text-center py-12">
          <div className="text-gray-500 text-lg">
            Please sign in to view system resources.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <SystemResourcesOverview />
    </div>
  );
};

export default SystemResources; 